import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import { IPermission } from '../../../../../../models/settingsV2.model';
import useService from '../../utils/useService';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { showAlert, app } = useContext(AppContext);
	const { requestUpdatePermissions } = useService();

	const location = useLocation();
	const data: IPermission = _get(location, ['state', 'rowData']);
	const updatePermissions = async (updatedData: IPermission) => {
		setShowLoader(true);
		try {
			const { _id, description } = updatedData;
			const response = await requestUpdatePermissions(app.appName, { _id, description });
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to editing permission');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while editing this Permission', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('Permission edited successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (submittedData: IPermission) => {
		updatePermissions(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEdit;
